const messageConfig = require("@/models/messageConfig")

const mediaBookingTypeValidator = (rule, value, callback, source) => {
  return source.contractType === "production" ||
    (source.contractType !== "production" &&
      (value || "") !== "")
}

const mediaRelateContractNumberValidator = (rule, value, callback, source) => {
  return source.mediaBookingType !== "renewal" || source.mediaBookingType !== "renewal" ||
    (source.mediaBookingType === "renewal" &&
      (value || "") !== "");
}

const productionBookingTypeValidator = (rule, value, callback, source) => {
  return source.contractType === "media" ||
    (source.contractType !== "media" &&
      (value || "")
        .split(">")
        .filter((t) => t !== "").length > 0)
}

const productionRelateContractNumberValidator = (rule, value, callback, source) => {
  return source.contractType === "media" || (source.productionBookingType || "").indexOf("newvisual") < 0 ||
    (source.contractType !== "media" &&
      (source.productionBookingType || "").indexOf("newvisual") >= 0 &&
      (value || "") !== "")
}
const intercomContractNumberValidator = (rule, value, callback, source) => {
    if (source.isITC == false) {
    return true;
  }
  return (value || "") !== "";
}

module.exports = {
  contractType: {
    required: true,
    message: messageConfig.getMessage("validformrequire")
  },
  mediaBookingType: {
    message: messageConfig.getMessage("contractinfovalidator"),
    validator: mediaBookingTypeValidator
  },
  mediaRelateContractNumber: {
    message: messageConfig.getMessage("validformrequire"),
    validator: mediaRelateContractNumberValidator
  },
  intercomContractNumber: {
    message: messageConfig.getMessage("validformrequire"),
    validator: intercomContractNumberValidator
  },
  productionBookingType: {
    message: messageConfig.getMessage("contractinfovalidator"),
    validator: productionBookingTypeValidator
  },
  productionRelateContractNumber: {
    message: messageConfig.getMessage("validformrequire"),
    validator: productionRelateContractNumberValidator
  }
}


